import { PercentProps } from 'components/shared/Percent/model';
import { PercentWithUnit } from 'components/shared/Percent/PercentWithUnit';
import { withIncrementers } from 'components/shared/Percent/WithIncrementers';
import { WithUnitProps } from 'components/shared/WithUnit/WithUnit';

export const PercentWithUnitAndIncrementers = withIncrementers<PercentProps & WithUnitProps>(PercentWithUnit, {
  layout: 'around',
});
